import React from 'react';

type EmbellishmentLocationItem = {
    topEdge: { active: boolean };
    bottomEdge: { active: boolean };
    leadReturnEdge: { active: boolean };
    totalStrips: number;
};

interface EmbellishmentDetailsProps {
    salesDescriptionSettingsMapped: { id: string; isEnabled: boolean }[];
    data: any;
}

const formatLocation = (item: EmbellishmentLocationItem, orderType: string): string => {
    const onTop = item.topEdge.active;
    const onBottom = item.bottomEdge.active;
    const onVertical = item.leadReturnEdge.active && (item.totalStrips > 0 || orderType === 'custom-order');

    let parts = [];
    if (onTop) parts.push("Top Edge");
    if (onBottom) parts.push("Bottom Edge");
    if (onVertical) {
        const plural = item.totalStrips > 1 ? "s" : "";
        const count = item.totalStrips || '';
        parts.push(`${count} Vertical Edge${plural}`);
    }

    if (parts.length === 0) return ".";

    let locationString = " on " + parts.join(', ');
    if (parts.length > 1) {
        const lastPartIndex = locationString.lastIndexOf(',');
        if (lastPartIndex !== -1) {
            locationString = locationString.substring(0, lastPartIndex) + ' and' + locationString.substring(lastPartIndex + 1);
        }
    }

    return locationString + ".";
};

export const EmbellishmentDetails: React.FC<EmbellishmentDetailsProps> = ({
    salesDescriptionSettingsMapped,
    data,
}) => {
    // const isEnabled = salesDescriptionSettingsMapped.some(
    //     (item) => item.id === "salesembellishmentsselected" && item.isEnabled
    // );

    // if (!isEnabled) {
    //     return null;
    // }

    const hasCheckedEmbellishments = data.embellishmentsList.some((e: any) => e.checked);

    const isTypeChecked = (title: string) =>
        data.embellishmentsList.some((e: any) => e.checked && e.title === title);

    const isOtherChecked = () =>
        data.embellishmentsList.some((e: any) => e.checked && e.stateName === "othersEmbellishments");

    return (
        <div>
            <span className="boldText">Embellishments:</span>
            <span className="nonBold">
                {!hasCheckedEmbellishments ? (
                    " None"
                ) : (
                    <>
                        {isTypeChecked("Banding") && data.bandings.map((banding: any, i: number) => (
                            <span key={`ban-${i}`}> Banding{formatLocation(banding, data.orderType)}</span>
                        ))}
                        {isTypeChecked("Cording") && data.cordings.map((cording: any, i: number) => (
                            <span key={`cor-${i}`}> Cording{formatLocation(cording, data.orderType)}</span>
                        ))}
                        {isTypeChecked("Flange") && data.flanges.map((flange: any, i: number) => (
                            <span key={`fla-${i}`}> Flange{formatLocation(flange, data.orderType)}</span>
                        ))}
                        {isTypeChecked("Trim") && data.trims.map((trim: any, i: number) => (
                            <span key={`tri-${i}`}> Trim{formatLocation(trim, data.orderType)}</span>
                        ))}
                        {isOtherChecked() && (
                            <span> {data.othersEmbellishments.map((o: any) => o.name).join(", ")}.</span>
                        )}
                    </>
                )}
            </span>
        </div>
    );
};